import Vue from 'vue';
import Router from 'vue-router';

import { Token } from '@/api/token';

import Chat from './views/chat/Chat.vue';
import Archive from './views/archive/Archive.vue';
import Auth from './views/auth/Auth.vue';
import Settings from './views/settings/Settings.vue';
import Dashboard from './views/dashboard/Dashboard.vue';
import Concierges from './views/concierges/Concierges.vue';
import ConciergeProfile from './views/concierge_profile/ConciergeProfile.vue';
import Guide from './views/guide/Guide.vue';
import Analytic from '@/views/analytic/Analytic.vue';

Vue.use(Router);

let MainRouter = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Root',
      component: Auth
    },
    {
      path: '/chat',
      name: 'Chat',
      component: Chat
    },
    {
      path: '/archive',
      name: 'Archive',
      component: Archive
    },

    {
      path: '/booking',
      name: 'Booking',
      component: Chat
    },
    {
      path: '/analytic',
      name: 'Analytic',
      component: Analytic
    },
    {
      path: '/guide',
      name: 'Guide',
      component: Guide
    },
    {
      path: '/payments',
      name: 'Payments',
      component: Chat
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/concierges',
      name: 'Concierges',
      component: Concierges
    },
    {
      // Note: Have to separate route, `children` does not work.
      path: '/concierges/:conciergeId',
      name: 'ConciergeProfile',
      component: ConciergeProfile
    }
  ]
});

MainRouter.beforeEach((to, from, next) => {
  let conciergeSession = Token.getConciergeSession();
  if (to.name == 'Root') {
    if (conciergeSession) {
      return next({ path: '/chat' });
    }
  } else {
    if (!conciergeSession) {
      return next({ path: '/' });
    }
  }

  return next();
});

export default MainRouter;
